<template>
    <div id="agent-listing-edit" class="agent-listing-edit">
        <b-form @submit="onSubmit">
            <b-col xl="10" lg="11" md="12">
                <b-form-group label="Listing Address" label-cols="3"
                              breakpoint="md" horizontal>
                    <b-form-input
                        id="address"
                        v-model="listing.UnparsedAddress"
                        type="text"
                        disabled
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Listing Type" label-cols="3">
                    <b-form-select v-model="listing_type_id" :options="options"></b-form-select>
                </b-form-group>

                <b-form-group label="Cooperating Commission" label-cols="3">
                    <b-input v-model="listing.commission"></b-input>
                    <small class="form-text text-muted">Enter the commission amount as a whole number, i.e. 3 for 3%</small>
                </b-form-group>

                <b-button type="submit" variant="primary">Submit</b-button>
            </b-col>
        </b-form>

        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>

import addressTemplate from './autocomplete/templates/address_template'

export default {
    name: 'agent-listing-edit',
    props: {
        agent: {
            type: Object,
            default: () => {}
        },
        listing: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            listing_type_id: this.listing.listing_type_id,
            options: [
                { value: null, text: 'Please select a Listing Type' },
                { value: 1, text: 'Listing Agent'},
                { value: 2, text: 'Buyer\'s Agent'},
            ],
            event: "",
            editing: true,
            isLoading: false,
        }
    },
    created () {

    },
    methods: {
        onSubmit() {
            let _self = this;
            _self.isLoading = true;
            let data = {
                agent: _self.agent,
                listing: _self.listing,
                listing_type_id: _self.listing_type_id,
                commission: _self.listing.commission,
            };
            axios.post('/api/agents/editListing', data)
                .then(function (response) {
                    _self.isLoading = false;
                    if (response.data.status === false) {
                        _self.$eventHub.$emit('app::message', 'error', 'Error', response.data.message);
                    } else {
                        _self.$eventHub.$emit('listing::added', "success");
                    }
                });
        }
    },
}

</script>
